import * as Actions from '../Actions/PesquisaPainelActions';
import _ from 'lodash';

const initialState = {
    open: [],
    count: {},
    clearPesquisa: {}
};

const PesquisaPainelReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.TOGGLE_PESQUISA:
            {
                let AOpen = [];
                let ACount = { ...state.count };
                let AClearPesquisa = { ...state.clearPesquisa };
                if (state.open.length < 1 || !state.open.includes(action.id)) {
                    AOpen = [...state.open];
                    AOpen.push(action.id);
                }
                else {
                    state.open.forEach(id => {
                        if (action.id !== id) {
                            AOpen.push(id);
                        }
                    });
                }
                if (!_.isNull(action.count)) {
                    ACount[action.id] = action.count;
                }

                if (!_.isNull(action.clearPesquisa)) {
                    AClearPesquisa[action.id] = action.clearPesquisa;
                }
                return {
                    ...state,
                    open: AOpen,
                    count: ACount,
                    clearPesquisa: AClearPesquisa,
                };
            }
        case Actions.CLOSE_ALL_PESQUISA:
            {
                let ACount = {};
                Object.keys(state.count).forEach(id => {
                    ACount[id] = 0;
                });
                return {
                    ...state,
                    open: [],
                    count: ACount,
                };
            }
        default:
            {
                return state;
            }
    }
};

const reducer = PesquisaPainelReducer;

export default reducer;